import Vue from 'vue'

Vue.directive('number', {               // 定义v-number指令，目前只针对el-input组件
    bind(el, binding, vnode: any) {
        const elInput = vnode.tag.includes('ElInputNumber') ? vnode.child.$refs.input : vnode.child
        let fn: Function = elInput.handleInput
        elInput.handleInput = function handleInput(e) {
            let numberBinding: any = vnode.child.numberBinding || binding || {}
            let val: any = e.target.value
            if (val != null && val.replace) {    // 处理粘贴数字的情况
                val = val.replace(/。/g, '.').replace(/[,\s]/g, '')
            }
            let reg1 = /^[-+]?\d*\.?\d*/
            let reg2 = /^([-+]?)0+(\d+)/
            let msg = ''
            if (val === '.') {
                val = ''
            } else if (numberBinding.value === 'positive') {   // 只允许输入正数和0
                reg1 = /^[+]?\d*\.?\d*/
                if (val < 0) {
                    val = ''
                }
                msg = 'Please input positive number'
            } else if (numberBinding.value === 'negative') {    // 只允许输入负数和0
                reg1 = /^[-0]\d*\.?\d*/
                if (val > 0) {
                    val = ''
                }
                msg = 'Please input negative number'
            } else if (numberBinding.value === 'noNegativeInteger') {   // 只允许输入非负整数（包括0）
                reg1 = /^[+]?\d*/
                if (val < 0) {
                    val = ''
                }
                msg = 'Please input positive integer number'
            } else if (numberBinding.value === 'positiveInt') {         // 只允许输入正整数（不包括0）
                reg1 = /^[+]?\d*/
                if (val <= 0) {
                    val = ''
                }
                msg = 'Please input positive integer number'
            } else if (numberBinding.value === 'positiveIntAndZero') {         // 只允许输入正整数（包括0）
                reg1 = /^[+]?\d*/
                msg = 'Please input positive integer number'
            } else if (numberBinding.value === 'decimalTwo') {          // 只允许输入两位小数 (包括负数和正数)
                reg1 = /^[-+]?\d*\.?\d{0,2}/
                msg = ''
            } else if (numberBinding.value === 'positiveDecimalTwo') {          // 只允许输入正数两位小数
                reg1 = /^[+]?\d*\.?\d{0,2}/
                msg = ''
            } else if (numberBinding.value === 'positiveDecimalTwoNotZero') {          // 只允许输入正数两位小数, 不允许输入0
                reg1 = /^[+]?\d*\.?\d{0,2}/
                if (val <= 0) {
                    val = ''
                }
                msg = ''
            } else if (numberBinding.value === 'integer') {             // 只允许输入整数（包括正整数和负整数）
                reg1 = /^[-+]?\d*/
                msg = 'Please input integer'
            } else if (numberBinding.value === 'decimalTwoEight') {          // 只允许输入8位 (包括负数和正数)
                reg1 = /^[-+]?\d{0,9}\.?\d{0,2}/
                msg = ''
            } else if (numberBinding.value === 'negativeDecimalTwo') {
                reg1 = /^[-]\d*\.?\d{0,2}/
                msg = ''
            } else if (numberBinding.value === 'positiveDecimalTwoUpTo100') {          // 只允许输入正数两位小数, 用于百分比，最大100%
                reg1 = /^[+]?\d*\.?\d{0,2}/
                if (val >= 100) {
                    val = ''
                }
                msg = 'Please input positive number and two decimal'
            } else if (numberBinding.value === 'onlyzero') {
                reg1 = /^0$/
                msg = ''
            }

            if (numberBinding.value === 'positiveDecimalTwo' || numberBinding.value === 'negativeDecimalTwo') {
                val = val.replace(/,/g, '')
            }

            val = (reg1.exec(val) || [''])[0]
            e.target.value = val.replace(reg2, '$1$2')
            if (val === '' && msg) {
                $AppMain.$message.closeAll()
                $AppMain.$message.warning(msg)
            }
            elInput.isComposing = false
            fn(e)
        }
        vnode.child.$forceUpdate()
    },
    componentUpdated(el, binding, vnode: any) { // 组件更新后设置binding，其他钩子函数中不能获取到最新的binding
        vnode.child.numberBinding = binding
    },
})

Vue.directive('letterAndNumber', {               // 只能输入字母和数字
    bind(el, binding, vnode: any) {
        const elInput = vnode.tag.includes('ElInputNumber') ? vnode.child.$refs.input : vnode.child
        let fn: Function = vnode.child.handleInput
        vnode.child.handleInput = function handleInput(e) {
            e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
            elInput.isComposing = false
            fn(e)
        }
        vnode.child.$forceUpdate()
    },
    componentUpdated(el, binding, vnode: any) { // 组件更新后设置binding，其他钩子函数中不能获取到最新的binding
        vnode.child.numberBinding = binding
    },
})

Vue.directive('numbers', {               // 只能输入数字
    bind(el, binding, vnode: any) {
        const elInput = vnode.tag.includes('ElInputNumber') ? vnode.child.$refs.input : vnode.child
        let fn: Function = vnode.child.handleInput
        vnode.child.handleInput = function handleInput(e) {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
            elInput.isComposing = false
            fn(e)
        }
        vnode.child.$forceUpdate()
    },
    componentUpdated(el, binding, vnode: any) { // 组件更新后设置binding，其他钩子函数中不能获取到最新的binding
        vnode.child.numberBinding = binding
    },
})

Vue.directive('defaultTime', {               // 只能输入字母和数字
    inserted(el, binding, vnode) {
        const component = vnode.componentInstance

        if (component) {
            // 备份原始的 change 回调
            const originChange = component.$listeners.change

            // 重新监听 change
            component.$on('change', val => {
                if (val) {
                    const defaultTime = binding.value || '00:00:00'
                    const [h, m, s] = defaultTime.split(':').map(Number)
                    const time = new Date(val).setHours(h, m, s, 0)
                    component.$emit('input', time)

                    // 调用原始监听器（如果外部还绑定了 @change）
                    if (originChange) {
                        if (Array.isArray(originChange)) {
                            originChange.forEach(fn => {
                                fn(time)
                            })
                        } else {
                            originChange(time)
                        }
                    }
                }
            })
        }
    },
    componentUpdated(el, binding, vnode: any) { // 组件更新后设置binding，其他钩子函数中不能获取到最新的binding
        vnode.child.numberBinding = binding
    },
})

Vue.directive('focus', {
    inserted(el) {
        if (el.tagName.toLocaleLowerCase() === 'input') {
            el.focus()
        } else {
            let list = el.getElementsByTagName('input')
            if (list.length) {
                list[0].focus()
            }
        }
    },
})


Vue.directive('autoBlur', { // el-select 选中后自动失焦
    update(el, binding, vnode: any) {
        const target = vnode.child
        target.blur()
    },
})

Vue.directive('resize', {
    bind(el: any, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = ''
        let height = ''
        function isReize() {
            const style = (document as any).defaultView.getComputedStyle(el)
            if (width !== style.width || height !== style.height) {
                binding.value({ width: style.width, height: style.height })
            }
            width = style.width
            height = style.height
        }
        el.__vueSetInterval__ = setInterval(isReize, 300)
    },
    unbind(el: any) {
        clearInterval(el.__vueSetInterval__)
    },
})

Vue.directive('name-limit', {               // 只能输入字母和数字
    bind(el, binding, vnode: any) {
        const elInput = vnode.tag.includes('ElInputNumber') ? vnode.child.$refs.input : vnode.child
        let fn: Function = vnode.child.handleInput
        vnode.child.handleInput = function handleInput(e) {
            let nameBinding: any = vnode.child.nameBinding || binding || {}
            console.log('nameBinding: ', nameBinding.value, typeof nameBinding.value)
            if (nameBinding.value !== false) {
                const haveForbidChar = /[^a-zA-Z@\/\-,()'. ]/.test(e.target.value)
                e.target.value = e.target.value.replace(/[^a-zA-Z@\/\-,()'. ]/g, '')
                elInput.isComposing = false
                if (haveForbidChar) {
                    $AppMain.$message.closeAll()
                    $AppMain.$message.warning(`Only English letters and English-format symbols (@ / - , () ' .) are permitted. Chinese input/symbols are not supported.`)
                }
            }
            fn(e)
        }
        vnode.child.$forceUpdate()
    },
    componentUpdated(el, binding, vnode: any) { // 组件更新后设置binding，其他钩子函数中不能获取到最新的binding
        vnode.child.nameBinding = binding
    },
})
